import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = [
    { value: 'UPPER_LEFT', label: '左上' },
    { value: 'UPPER_RIGHT', label: '右上' },
    { value: 'LOWER_LEFT', label: '左下' },
    { value: 'LOWER_RIGHT', label: '右下' },
];

const FORMAT_OPTIONS = [
    { value: 'DATETIME', label: '日時', tooltip: '年月日 時分秒（YYYY/MM/DD HH:MM:SS）' },
    { value: 'DATE', label: '日付', tooltip: '年月日（YYYY/MM/DD）' },
    { value: 'TIME', label: '時刻', tooltip: '時分秒（HH:MM:SS）' },
];

defineBlock({
    type: 'gps_datetime',
    colour: CATEGORIES.gps.color,
    tooltip: 'GPSセンサーから日時・日付・時刻を取得します',
    movable: true,
    deletable: true,
    output: 'String',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/gps.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('GPS', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('日時'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: CATEGORIES.gps.color,
                    options: POSITION_OPTIONS,
                },
                { type: 'label', text: 'で' },
                {
                    type: 'field',
                    name: 'FORMAT',
                    instance: () =>
                        new FieldOperatorDropdown(FORMAT_OPTIONS, 'DATETIME', undefined, CATEGORIES.gps.color),
                },
                { type: 'label', text: 'を取得する ' },
            ],
        },
    ],
    onInit(this: Blockly.Block) {
        this.setOutputShape(3);
    },
});
